var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { accountEntityName } from '../../../../../backend/features/accounts/shared';
import { groupEntityName } from '../../../../../backend/features/groups/shared';
import { showGroupsWithCustomFieldsDialog } from '../../../../../ui/features/classifiers-admin-pages/components/CustomFields/components';
import { StorageClient } from '@juvare/platform-sdk-js/StorageClient';
import { DynamicColumnsAdminPageNew } from '@juvare/platform-sdk-react/ui/features/dynamic-columns';
import React from 'react';
export const DynamicColumnsPage = () => {
    return (React.createElement(DynamicColumnsAdminPageNew, { entities: [accountEntityName], onBeforeDelete: (column) => __awaiter(void 0, void 0, void 0, function* () {
            const groupStorage = new StorageClient(groupEntityName);
            const groups = yield groupStorage.list({
                filter: [{ column: 'filterByColumns', op: 'overlap', value: ['_dynamic_' + column.name] }],
                limit: 1,
            });
            if (groups.total === 0) {
                return true;
            }
            else {
                showGroupsWithCustomFieldsDialog(column.name);
                return false;
            }
        }) }));
};
